import * as React from 'react';
import { Entity, Permiso } from '../utilities/Permisos';
import { AppBar, Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, Slide, Stack, TextField, Toolbar, Typography } from '@mui/material';
import { GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext, GridCsvExportOptions, GridToolbarContainer, DataGrid, GridRowSelectionModel, GridPaginationModel, GridCallbackDetails, GridRowId } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Common from '../utilities/common';
import $ from "jquery";
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import { User } from '../Settings/Users/User';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'permisos' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export interface IEntityPermissionsProps {
    entity: Entity;
    onOpen?: any;
    onClose?: any;
    showAsButton?: boolean;
}

export interface IEntityPermissionsState {
    data: any[];
    currentPage: number;
    open: boolean;
    selectedRow: GridRowId[];
    openNewDialog: boolean;
    openDeleteDialog: boolean;
    users: User[];
}

export default class EntityPermissions extends React.Component<IEntityPermissionsProps, IEntityPermissionsState> {
    _permiso: Permiso = new Permiso();

    public constructor(props: IEntityPermissionsProps) {
        super(props);

        this.state = {
            data: [],
            currentPage: 0,
            open: false,
            selectedRow: [],
            openNewDialog: false,
            openDeleteDialog: false,
            users: []
        }
    }

    componentDidMount(): void {
        this.Get();
        this.GetUsers();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.props.showAsButton != null && this.props.showAsButton && (
                        <Button variant='text' startIcon={<SecurityOutlinedIcon />} onClick={() => {
                            this.setState(
                                {
                                    open: true
                                }
                            );

                            if(this.props.onOpen != null) {
                                this.props.onOpen();
                            }
                        }}>
                            Permisos
                        </Button>
                    )
                }
                {
                    this.props.showAsButton == null || !this.props.showAsButton && (
                        <ListItemButton
                            onClick={() => {
                                this.setState(
                                    {
                                        open: true
                                    }
                                );

                                if(this.props.onOpen != null) {
                                    this.props.onOpen();
                                }
                            }}
                        >
                            <ListItemIcon>
                                <SecurityOutlinedIcon />
                            </ListItemIcon>
                            <ListItemText primary={'Permisos'} />
                        </ListItemButton>
                    )
                }
                <Dialog open={this.state.open} fullWidth={true} maxWidth={'lg'}>
                    <DialogTitle>
                        <Stack direction={'row'} justifyContent={'space-between'}>
                            <Typography variant='h5'>
                                {
                                    `Permisos para ${Common.GetEntityName(this.props.entity)}`
                                }
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => {
                                    this.setState({
                                        selectedRow: [],
                                        open: false
                                    });

                                    if(this.props.onClose != null) {
                                        this.props.onClose();
                                    }
                                }}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </DialogTitle>
                    <DialogContent>
                        <DataGrid
                            autoHeight
                            slots={{ toolbar: CustomToolbar }}
                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                            rows={this.state.data}
                            columns={[
                                { field: 'userName', headerName: 'Email', width: 300 },
                                { field: 'permiso', headerName: 'Nivel de permisos', width: 200}
                            ]}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: this.state.currentPage, pageSize: 30 },
                                },
                            }}
                            pageSizeOptions={[30, 60, 100]}
                            checkboxSelection={true}
                            onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                this.setState({
                                    selectedRow: row
                                });
                            }}
                            onPaginationModelChange={(model: GridPaginationModel, details: GridCallbackDetails) => {
                                this.setState({
                                    currentPage: model.page
                                });
                            }}
                            hideFooter={this.state.data.length <= 30}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={() => {
                            this.setState({
                                openNewDialog: true
                            })
                        }}>Dar permiso</Button>
                        {
                            this.state.selectedRow.length > 0 && (
                                <Button variant='contained' onClick={() => {
                                    this.setState(
                                        {
                                            openDeleteDialog: true
                                        }
                                    );
                                }}>Eliminar permiso</Button>
                            )
                        }
                        {
                            this.state.selectedRow.length == 1 && (
                                <Button variant='contained'>Modificar permiso</Button>
                            )
                        }
                        <Button variant='contained' onClick={() => {
                            this.setState({
                                selectedRow: [],
                                open: false
                            });

                            if(this.props.onClose != null) {
                                this.props.onClose();
                            }
                        }}>Cerrar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.openNewDialog} fullWidth>
                    <DialogTitle>
                        Asignar permisos
                    </DialogTitle>
                    <DialogContent>
                        <FormControl variant="standard" fullWidth style={{marginBottom: '20px'}}>
                            <InputLabel id="labelUsuarios">Usuarios</InputLabel>
                            <Select label="Errores" labelId='labelUsuarios' style={{textAlign: 'left'}} onChange={(event: SelectChangeEvent) => {
                                this._permiso.userId = Number(event.target.value);
                            }}>
                                {
                                    this.state.users.map((value: User, index: number) => {
                                        return(
                                            <MenuItem value={value.id} key={index}>
                                                {
                                                    value.userName
                                                }
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="labelPermisos">Permiso</InputLabel>
                            <Select label="Errores" labelId='labelPermisos' style={{textAlign: 'left'}} onChange={(event: SelectChangeEvent) => {
                                this._permiso.nivelPermisoId = Number(event.target.value);
                            }}>
                                <MenuItem value={1}>Ver</MenuItem>
                                <MenuItem value={2}>Editar</MenuItem>
                                <MenuItem value={3}>Eliminar</MenuItem>
                                <MenuItem value={4}>Crear</MenuItem>
                                <MenuItem value={5}>Administrar</MenuItem>
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={this.Set.bind(this)}>Dar permiso</Button>
                        <Button variant='contained' onClick={() => {
                            this.setState({
                                openNewDialog: false
                            })
                        }}>Cerrar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.openDeleteDialog} fullWidth>
                    <DialogTitle>
                        Eliminar permisos
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.selectedRow.length == 1 && (
                                `¿Desea eliminar el permiso seleccionado?`
                            )
                        }
                        {
                            this.state.selectedRow.length > 1 && (
                                `¿Desea eliminar los permisos seleccionados?`
                            )
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.StartDelete.bind(this)}>OK</Button>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    openDeleteDialog: false
                                }
                            )
                        }}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }

    private Get(): void {
        let url = `${Common.END_POINT}/permissions/byentity/${this.props.entity}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    openNewDialog: false,
                    openDeleteDialog: false
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    private GetUsers(): void {
        let url = `${Common.END_POINT}/masters/users`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    users: response
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private Set() {
        this._permiso.entidadId = this.props.entity;

        let url = `${Common.END_POINT}/permissions`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._permiso),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.Get();

            this._permiso = new Permiso();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this._permiso = new Permiso();
        });
    }

    private StartDelete() {
        this.Delete(0);
    }

    private Delete(index: number): void {
        if(index >= this.state.selectedRow.length) {
            this.Get();
        }

        let url = `${Common.END_POINT}/permissions/${this.state.selectedRow[index]}/delete`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.Delete(index + 1);
        })
    }
}